var HybridBootstrap; // Used to bootstrap Angular module.
